import u from "./Notification.vue2.mjs";
import { resolveComponent as l, openBlock as t, createBlock as f, Teleport as k, createVNode as n, Transition as y, withCtx as c, createElementBlock as o, mergeProps as h, normalizeClass as v, normalizeStyle as $, createCommentVNode as s, createElementVNode as i, renderSlot as a, toDisplayString as d, createTextVNode as g } from "vue";
import "./Notification.vue3.mjs";
import w from "../../_virtual/_plugin-vue_export-helper.mjs";
const z = { class: "p-4" }, _ = { class: "flex items-start" }, b = {
  key: 0,
  class: "mr-3 shrink-0"
}, C = { class: "w-0 flex-1" }, B = { class: "text-sm font-medium text-zinc-900 dark:text-white" }, N = {
  key: 0,
  class: "mt-1 text-sm text-zinc-500 dark:text-zinc-100"
}, T = {
  key: 1,
  class: "mt-3 flex space-x-7"
}, I = {
  key: 1,
  class: "ml-4 flex shrink-0"
};
function S(e, r, V, E, M, X) {
  const m = l("XMarkIcon"), p = l("IconButton");
  return e.mounted ? (t(), f(k, {
    key: 0,
    to: "#tui-notifications",
    disabled: e.disableTeleport
  }, [
    n(y, {
      "enter-active-class": "transition duration-300 ease-out transform",
      "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
      "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
      "leave-active-class": "transition duration-100 ease-in",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0",
      onAfterLeave: r[0] || (r[0] = (A) => e.$emit("hidden"))
    }, {
      default: c(() => [
        e.show ? (t(), o("div", h({
          key: 0,
          class: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5 dark:bg-zinc-750 dark:ring-zinc-700"
        }, e.$attrs), [
          e.autoClose ? (t(), o("div", {
            key: 0,
            class: v(["tui-notification-progress h-1", e.progressClasses]),
            style: $(e.progressStyles)
          }, null, 6)) : s("", !0),
          i("div", z, [
            i("div", _, [
              e.$slots.icon ? (t(), o("div", b, [
                a(e.$slots, "icon")
              ])) : s("", !0),
              i("div", C, [
                i("p", B, d(e.title), 1),
                e.description || e.$slots.default ? (t(), o("p", N, [
                  a(e.$slots, "default", {}, () => [
                    g(d(e.description), 1)
                  ])
                ])) : s("", !0),
                e.$slots.actions ? (t(), o("div", T, [
                  a(e.$slots, "actions")
                ])) : s("", !0)
              ]),
              e.closeable ? (t(), o("div", I, [
                n(p, {
                  class: "size-4",
                  size: "sm",
                  type: "submit",
                  onClick: e.close
                }, {
                  default: c(() => [
                    n(m, { "aria-hidden": "true" })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])) : s("", !0)
            ])
          ])
        ], 16)) : s("", !0)
      ]),
      _: 3
    })
  ], 8, ["disabled"])) : s("", !0);
}
const q = /* @__PURE__ */ w(u, [["render", S]]);
export {
  q as default
};
//# sourceMappingURL=Notification.vue.mjs.map
